import _classCallCheck from "/var/www/heritagemedical.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/heritagemedical.com/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Node Class as base class for TextNode and HTMLElement.
 */
var Node = /*#__PURE__*/function () {
  function Node() {
    _classCallCheck(this, Node);

    this.childNodes = [];
  }

  _createClass(Node, [{
    key: "innerText",
    get: function get() {
      return this.rawText;
    }
  }]);

  return Node;
}();

export { Node as default };